import React from "react";
import "./Footer.css";
import email from "../images/footer/email.png";
import facebook from "../images/footer/facebook.png";
import instagram from "../images/footer/instagram.png";

const Footer = () => {
    return (
    <footer className="footer" id="footer">
      
      <h2>CONTACT US</h2>
      <div className="footer-container-wrapper">
      <div className="footer-container">

      

        {/* MIDDLE - CONTACT */}
        <div className="footer-section">
          <h3>Meet Us At!</h3>

          
          <p>
  <img className="footerIcon" src={email} alt="Email Icon" />
  <a href="mailto:flamingotours49@gmail.com">
    flamingotours49@gmail.com
  </a>
</p>
           <p>
              <img className="footerIcon" src={facebook} alt="Facebook Icon" />
              <a
                href="https://www.facebook.com/share/1KcckFpgXU/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Flamingo Tours and Travels
              </a>
            </p>

            <p>
              <img className="footerIcon" src={instagram} alt="Instagram Icon" />
              <a
                href="https://www.instagram.com/flamingo_tours_travels?igsh=MWJpbHpmZ3h3Y3BoMg=="
                target="_blank"
                rel="noopener noreferrer"
              >
                flamingo_tours_travels
              </a>
            </p>
        </div>

        {/* RIGHT - MAP */}
        <div className="footer-section">
          <h3>Location</h3>

          <iframe
            title="map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6129.9215206578765!2d88.62712398878875!3d27.336786512759577!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39e6a5d4db62ac3d%3A0xc66c77b6162e5dbe!2sFlamingo%20tours%20and%20travel!5e1!3m2!1sen!2sin!4v1779548402991!5m2!1sen!2sin"
          ></iframe>
        </div>

      </div>
      </div>
      <div className="footer-bottom">
        ©2026, Flamingo Tours and Travels. "All rights reserved"
      </div>

    </footer>
  );
};

export default Footer;